import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CategoryCard = ({ category, index = 0 }) => {
  const isIllustration = (category.image_url || "").startsWith("/categories/");
  return (
    <Link
      to={`/categorie/${category.slug}`}
      className="group block relative overflow-hidden bg-bl-surface border border-bl-border"
      data-testid={`category-card-${category.slug}`}
    >
      <div className={`cat-illu-wrap aspect-[4/5] overflow-hidden ${isIllustration ? "bg-white" : "bg-bl-soft"}`}>
        <img
          src={category.image_url}
          alt={category.name}
          loading="lazy"
          className={`w-full h-full ${
            isIllustration
              ? "object-contain p-6 cat-illu"
              : "object-cover product-image-zoom"
          }`}
        />
      </div>
      <div className="px-6 py-6 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <span className="overline text-bl-dore">
            {String(index + 1).padStart(2, "0")} · {category.letter}
          </span>
          <ArrowUpRight size={18} strokeWidth={1.4} className="text-bl-text" />
        </div>
        <h3 className="font-serif text-3xl text-bl-text leading-tight">{category.name}</h3>
        <p className="text-sm text-bl-textSoft italic font-serif">« {category.tagline} »</p>
      </div>
    </Link>
  );
};
